import { __assign, __rest } from "tslib";
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { hideInAppHelpButton, showInAppHelpButton, } from '../utilities/inAppHelpUtils';
import './Portal.scss';
var PortalTypes = {
    LARGE: 'large',
    SIDE_PANEL: 'sidePanel',
    SMALL: 'small',
    BOTTOM_PANEL: 'bottomPanel'
};
// Add class to body when the portal is open. This removes scrolling on the body.
var PORTAL_OVERLAY_CLASS = 'body--hasPortalOverlay';
var Portal = function (_a) {
    var children = _a.children, className = _a.className, hasOverlay = _a.hasOverlay, isOpen = _a.isOpen, portalClassName = _a.portalClassName, type = _a.type, props = __rest(_a, ["children", "className", "hasOverlay", "isOpen", "portalClassName", "type"]);
    var portalRef = useRef(null);
    if (!portalRef.current) {
        portalRef.current = document.createElement('div');
    }
    // Manage locking scroll
    useEffect(function () {
        if (isOpen && hasOverlay) {
            document.body.classList.add(PORTAL_OVERLAY_CLASS);
        }
        return function () { return document.body.classList.remove(PORTAL_OVERLAY_CLASS); };
    }, [isOpen, hasOverlay]);
    // Manage appending/removing Modal to DOM
    useEffect(function () {
        if (portalRef.current) {
            document.body.appendChild(portalRef.current);
        }
        return function () {
            if (portalRef.current) {
                document.body.removeChild(portalRef.current);
            }
        };
    }, []);
    // Hide the in-app help button so it doesn't collide with portal content
    useEffect(function () {
        if (isOpen) {
            hideInAppHelpButton();
        }
        return showInAppHelpButton;
    }, [isOpen]);
    var portalClass = classnames('Portal', "Portal--".concat(type), portalClassName, {
        'Portal--hasOverlay': hasOverlay
    });
    var portalContentClass = classnames('Portal__content', "Portal__content--".concat(type), className);
    return isOpen
        ? createPortal(React.createElement("div", __assign({}, props, { className: portalClass }),
            React.createElement("div", { className: portalContentClass }, children)), portalRef.current)
        : null;
};
Portal.defaultProps = {
    hasOverlay: true,
    isOpen: false,
    type: PortalTypes.LARGE
};
Portal.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    hasOverlay: PropTypes.bool,
    isOpen: PropTypes.bool,
    portalClassName: PropTypes.string,
    type: PropTypes.oneOf(Object.values(PortalTypes))
};
export default Portal;
//# sourceMappingURL=Portal.js.map